import { createAction, props } from '@ngrx/store'
import { AuthData } from 'app/shared/model/auth-data.model';
import { Role } from 'app/shared/model/enums';

export const setAuthData = createAction('[Auth Service] Token', props<{ token: string, email: string, ownerFullName?: string, businessName: string,isAtn:boolean }>());
export const setUserInfo = createAction('[Auth Service] User Info', props<{ ownerFullName: string, businessName: string,isAtn:boolean }>());
export const clearAuthData = createAction('[Auth Service] Logout');
export const setLastEmail = createAction('[Auth Service] setLastEmail', props<{ email: string }>());



